import { Stat } from '../types';

export const stats: Stat[] = [
  { value: '420', label: 'Productions delivered', suffix: '+' },
  { value: '37', label: 'Countries staged in' },
  { value: '1.8', label: 'Million guests hosted', suffix: 'M' },
  { value: '14', label: 'Years on the road' },
];
